import styled, { css } from 'styled-components';
import Color from '@styles/Color';

export const defaultInputStyle = css<{
  isFocus?: boolean;
}>`
  padding: 8px 12px;

  &:hover,
  &:focus {
    border: 1px solid var(--primaryColor);
  }

  &:focus {
    box-shadow: 1px 1px 4px var(--inkColor), -1px -1px 4px var(--inkColor);
  }

  &::placeholder {
    font-size: var(--textSize);
    color: var(--subTextColor);
  }

  ${({ isFocus }) =>
    isFocus &&
    `box-shadow: 1px 1px 4px var(--inkColor), -1px -1px 4px var(--inkColor)`};
`;

export const validInputStyle = css<{
  isFocus?: boolean;
}>`
  border: 1px solid ${Color.RED_8};
  color: var(--textColor);
  padding: 8px 12px;

  &:hover,
  &:focus {
    border: 1px solid ${Color.RED_9};
  }

  &::placeholder {
    font-size: var(--textSize);
  }

  &:focus {
    box-shadow: 1px 1px 4px ${Color.RED_6}, -1px -1px 4px ${Color.RED_6};
  }
  ${({ isFocus }) =>
    isFocus &&
    `box-shadow: 1px 1px 4px ${Color.RED_6}, -1px -1px 4px ${Color.RED_6};`}
`;

export const baseInputStyle = css`
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  transition: 0.2s;
  border-radius: var(--cardBorderRadius);
  outline: none;
  font-size: var(--textSize);
  font-family: var(--defaultFontFamily);
  color: var(--textColor);
  border: 1px solid var(--lineColor);
  background-color: var(--cardBackgroundColor);
  backdrop-filter: blur(8px);

  @media (max-width: 768px) {
    /* 모바일 Safari에서 타이핑 중 리페인트 비용을 줄인다. */
    backdrop-filter: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &::placeholder {
    user-select: none;
  }
`;

const InputBase = styled.input<{
  isValid?: boolean;
  block?: boolean;
  disabled?: boolean;
}>`
  width: 100%;
  outline: none;

  ${baseInputStyle}
  ${({ isValid }) => (!isValid ? defaultInputStyle : validInputStyle)}
`;

export default InputBase;
